import React, { useState } from 'react'
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { v4 as uuidv4 } from "uuid"

import Button from '../../../../Components/Button/Button'
import Help from '../../../../Components/Help/Help'
import { serviceConsumer } from '../../../../network/ServiceConsumer'
import { useLocation, useNavigate } from 'react-router-dom'
import HeaderOrg from '../../../Headers/HeaderOrg'
import "../FeisCompetitor.css"
import Loader from '../../../../Components/Loader/Loader'
import SingleLineTitle from '../../../../Components/TitleElements/SingleLineTitle'
import edit from "../../../../Assets/edit-comp-action.svg"
import sort from "../../../../Assets/managefeisGrade/sort-org.svg"
import { groupAndSortComp } from '../../../../helper/SortSyllabus'
import { ShowToastMessage } from '../../../../helper/ShowToastMessage';
import ConfirmDeleteModal from '../../../../Components/Modals/OrganizerModel/ManageFeis/Tabulate/ConfirmDeleteModal';
import { getSortOrder } from '../../../../helper/CompTableSearch';

// Big enough to pull the whole event in one request when "Show All" is used.
const LOAD_ALL = 100000;

const EditCompetitors = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const eventId = searchParams.get('id');
    const navigate = useNavigate()
    const eventName = location?.state?.eventName

    const [tableArr, setTableArr] = useState([])
    const [total, setTotal] = useState(0)
    const [searchInput, setSearchInput] = useState("")
    const [hasFetched, setHasFetched] = useState(false)
    const [lastQuery, setLastQuery] = useState("") // term the shown results are for
    const [sorterData, setSorterData] = useState("")
    const [sortOrder, setSortOrder] = useState("asc")
    const [loading, setLoading] = useState(false)
    const [err, setErr] = useState("")
    const [dancerToBeDeleted, setDancerToBeDeleted] = useState()
    const [openModal, setOpenModal] = useState(false)

    // Nothing loads on arrival — the organizer searches, or asks for everyone.
    const fetchList = async (searchVal) => {
        const url = `${process.env.REACT_APP_BASE_URL}/feis/${eventId}/dancers?page=1&limit=${LOAD_ALL}&search=${encodeURIComponent(searchVal)}`;
        try {
            setLoading(true)
            setErr("")
            const response = await serviceConsumer("GET", url)
            setTableArr(response?.result || [])
            setTotal(response?.total ?? (response?.result?.length || 0))
            setHasFetched(true)
            setLastQuery(searchVal)
        } catch (error) {
            setErr(error?.messages || "Could not load competitors")
        } finally {
            setLoading(false)
        }
    }

    const submitSearch = (e) => {
        if (e) e.preventDefault();
        if (!searchInput.trim()) return;
        fetchList(searchInput.trim());
    }

    const showAll = () => {
        setSearchInput("");
        fetchList("");
    }

    // Sort the loaded rows on demand.
    const sortCompetitorsHandler = (sorter) => {
        let order = getSortOrder(sorter, sorterData, sortOrder);
        const tableArrCopy = [...tableArr]
        order === "asc" && sorter === "id" && tableArrCopy.sort((a, b) => a.card_number - b.card_number)
        order === "asc" && sorter === "competitor" && tableArrCopy.sort((a, b) => `${a.dancerData?.fname} ${a.dancerData?.lname}`.localeCompare(`${b.dancerData?.fname} ${b.dancerData?.lname}`))
        order === "asc" && sorter === "dob" && tableArrCopy.sort((a, b) => a.dancerData.birthday - (b.dancerData.birthday))

        order === "desc" && sorter === "id" && tableArrCopy.sort((a, b) => b.card_number - a.card_number);
        order === "desc" && sorter === "competitor" && tableArrCopy.sort((a, b) => `${b.dancerData?.fname} ${b.dancerData?.lname}`.localeCompare(`${a.dancerData?.fname} ${a.dancerData?.lname}`));
        order === "desc" && sorter === "dob" && tableArrCopy.sort((a, b) => b.dancerData.birthday - (a.dancerData.birthday));

        setTableArr(tableArrCopy)
        setSorterData(sorter)
        setSortOrder(order)
    }

    const editClickHandler = (dancer) => {
        navigate(`/edit-register/${eventName}?id=${eventId}&regId=${dancer._id}`)
    }
    const deleteClickHandler = (dancer) => {
        setDancerToBeDeleted(dancer)
        setOpenModal(true)
    }
    const closeModalHandler = () => {
        setDancerToBeDeleted("")
        setOpenModal(false)
    }
    const deleteDancerHandler = async () => {
        const url = `${process.env.REACT_APP_BASE_URL}/feis/remove-dancer`;
        const payload = { eventId: eventId, dancerId: dancerToBeDeleted?.dancerData?._id }
        setLoading(true)
        try {
            const response = await serviceConsumer("POST", url, payload)
            closeModalHandler()
            ShowToastMessage("success", response?.message)
            fetchList(lastQuery) // refresh the current view
        } catch (err) {
            ShowToastMessage("error", err?.messages)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {loading && <Loader />}
            <HeaderOrg />
            <SingleLineTitle titleName="Edit Competitor" />
            <div className="org-body-white">
                <div className="d-flex gap-2 align-items-center mt-3">
                    <div className="org-body-title">Competitors</div>
                    {hasFetched && <div className="competitor-count ">{total}</div>}
                </div>
                <div className="mb-3 hr-org-body" />
                <div className="search-label" style={{ marginTop: "33px" }}>Search:</div>
                <form onSubmit={submitSearch} className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                    <input type="text" value={searchInput} onChange={(e) => { setErr(""); setSearchInput(e.target.value) }} placeholder="Search by name, school or number…" className="searchFeisComp searchFeisComps" />
                    <Button type="submit" className={searchInput.trim() ? "filled" : "disabled"}>Search</Button>
                    <Button type="button" className="outlined" onClick={showAll}>Show All</Button>
                </form>

                {!hasFetched && !loading && (
                    <div className="d-flex justify-content-center my-5 text-center" style={{ color: "#797979" }}>
                        Search for a competitor by name, school, or number — or use “Show All” to load everyone in this event.
                    </div>
                )}

                {hasFetched && (
                    <div style={{ width: "100%", overflowX: "scroll", marginTop: "30px", marginBottom: "24px" }}>
                        <table className="table my_table competitorTable ">
                            <tbody>
                                <tr className="header-row">
                                    <td className=" mx-5 w-10 p-5-25">#&nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("id")} />
                                    </span></td>
                                    <td className="mx-5 w-25 p-25-5">Competitor&nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("competitor")} />
                                    </span></td>
                                    <td className="w-10 p-25-5">DOB&nbsp;<span>
                                        <img className="cursor-pointer" src={sort} alt="" onClick={() => sortCompetitorsHandler("dob")} />
                                    </span></td>
                                    <td className="w-25 p-25-5">Competitions</td>
                                    <td className="w-10 p-25-5 text-center">Action</td>
                                </tr>

                                {tableArr.map((dancer) => {
                                    return <tr style={{ fontSize: "12px", height: "61px" }} key={uuidv4()}>
                                        <td className=" mx-5 w-10 grey-30 p-5-25" >{dancer?.card_number}</td>
                                        <td className="mx-5 w-25 grey-30" ><div>{dancer?.dancerData?.fname}&nbsp;{dancer?.dancerData?.lname}<div style={{ opacity: "0.3" }}>{dancer?.dancerData?.school}</div></div></td>
                                        <td className="w-10 grey-30" >{dancer?.dancerData?.birthday}</td>
                                        <td className="w-25 grey-30">{dancer?.competitonData && groupAndSortComp(dancer?.competitonData).map((item, index) => { return (dancer?.competitonData?.length === index + 1) ? item?.code : `${item?.code}, ` })}</td>
                                        <td className="w-10 text-center">
                                            {dancer?.dancerData?.status
                                                ?
                                                <>
                                                    <img onClick={() => editClickHandler(dancer)} style={{ cursor: "pointer" }} src={edit} alt="edit" />
                                                    <DeleteOutlineOutlinedIcon
                                                        style={{ color: "red", marginLeft: "10px", cursor: "pointer" }}
                                                        onClick={() => deleteClickHandler(dancer)}
                                                    />
                                                </>
                                                : <DeleteOutlineOutlinedIcon
                                                    style={{ color: "red", marginLeft: "10px", cursor: "pointer" }}
                                                    onClick={() => deleteClickHandler(dancer)}
                                                />}
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                        {!loading && total === 0 && lastQuery !== '' && <div className="d-flex justify-content-center my-5">No competitors match “{lastQuery}”.</div>}
                        {!loading && total === 0 && lastQuery === '' && <div className="d-flex justify-content-center my-5">There are no competitors registered for this event</div>}
                        {!loading && err && <div className="d-flex justify-content-center my-5 error-class">{err}</div>}
                    </div>
                )}
            </div >
            <ConfirmDeleteModal modalState={openModal} confirm={deleteDancerHandler} cancel={closeModalHandler} dancerPage={true} />
            <Help />
        </>
    )
}

export default EditCompetitors
